var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }